import { useEffect } from 'react';
import { useSelector, connect, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';

// routing
import Routes from 'routes';

// defaultTheme
import themes from 'themes';

// project imports
import NavigationScroll from 'layout/NavigationScroll';
import { set_auth_token } from 'store/actions';
import { MENU_OPEN } from 'store/action-types';

const mapDispatchToProps = (dispatch) => {
  return {
    setAuthToken: (data) => dispatch(set_auth_token(data))
  };
};

const ids = {
  '/': 'default',
  '/infrastructure': 'default',
  '/locations': 'locations',
  '/turbines': 'turbines',
  '/forecasts': 'forecasts',
  '/sources': 'sources',
  '/comparison': 'comparison'
};

// ==============================|| APP ||============================== //

const App = ({ setAuthToken }) => {
  const customization = useSelector((state) => state.customization);
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: MENU_OPEN, id: ids[`/${location.pathname.split('/')[1]}`] });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  useEffect(() => {
    const token = localStorage.getItem('token');

    if (token) {
      setAuthToken(token);
    }
  }, [setAuthToken]);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={themes(customization)}>
        <CssBaseline />
        <NavigationScroll>
          <Routes />
        </NavigationScroll>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

App.propTypes = {
  setAuthToken: PropTypes.func
};

export default connect(null, mapDispatchToProps)(App);
